import api from "_config/api";

// Resposta da rota do backend GET api/v1/endereco/cep/{cep} (host cidadão).
// A rota é o proxy do ViaCEP do CIDAX, reutilizável nos 2 hosts.
export interface EnderecoCep {
  cep: string;
  logradouro: string;
  complemento: string;
  unidade: string;
  bairro: string;
  localidade: string;
  uf: string;
  estado: string;
}

// Busca o endereço por CEP na API do CIDAX. Retorna null quando o CEP é
// inválido (≠ 8 dígitos) ou não é encontrado (backend responde vazio/204).
export const fetchEnderecoPorCep = async (
  cep: string
): Promise<EnderecoCep | null> => {
  const cepDigits = cep.replace(/\D/g, "");
  if (cepDigits.length !== 8) return null;

  const { data, status } = await api.get<EnderecoCep>(
    `api/v1/endereco/cep/${cepDigits}`
  );

  if (status === 204 || !data) return null;

  return data;
};
